<template>
	<section v-if="relatedArticles.length" class="marketing-section bg-color-bg-tertiary">
		<div class="container">
			<h2 v-if="heading" class="heading-2 mb-200 text-align-center font-weight-lighter"> {{ heading }} </h2>
			<ArticleCardHorizontal
				v-for="article in relatedArticles"
				:key="article._id"
				:article="article"
				classes="py-150"
				:show-date="true"
			/>
		</div>
	</section>
</template>

<script setup lang="ts">
import ArticleCardHorizontal from '@components/blog/article-card-horizontal.vue';
import { SanityArticleTeaser } from 'types/sanity/education-center';
interface Props {
	heading?: string;
	relatedArticles: Array<SanityArticleTeaser>;
}
defineProps<Props>();
</script>
